import { NO_ELEMENT } from 'utils';
import { Section } from 'components/Section';
import { Cell, Grid } from 'components/Grid';
import { PopularCategoriesBlock } from 'models/PopularCategoriesBlock';
import { Card, CardContact } from 'components/Card';
import { useSelector } from 'react-redux';
import { isMobile as isMobileSelector } from 'components/Shared/responsive';
import { Appearances } from 'models/SectionBlock';
import styles from './categories.scss';
import { selectPhonenumber } from 'components/Footer/selector';
import { isStartPage } from './selector';

export const Categories = ({ categories }: PopularCategoriesBlock) => {
  const isMobile = useSelector(isMobileSelector);
  const phone = useSelector(selectPhonenumber);
  const startPage = useSelector(isStartPage);
  const gutterSize = isMobile ? 'large' : 'medium';

  if (!categories) {
    return NO_ELEMENT;
  }

  return (
    <Section isDesktop={!isMobile} appearance={Appearances.Tertiary}>
      <Grid
        huge="5"
        desktop="4"
        large="3"
        tablet="3"
        phone="2"
        gutters={gutterSize}
        className={styles.gridStyling}
      >
        {startPage && (
          <Cell>
            <CardContact button={{ title: phone }} />
          </Cell>
        )}
        {categories.map((item, index) => (
          <Cell key={index}>
            <Card
              appearance="simpleCard"
              button={{ title: item.title }}
              categoryUrl={item.url}
              image={item.image}
            />
          </Cell>
        ))}
      </Grid>
    </Section>
  );
};
